export default {
  state: {
    activeBlindBoxVoucher: '',
  },
  mutations: {
    SET_ACTIVE_BLIND_BOX_VOUCHER(state, data) {
      state.activeBlindBoxVoucher = data;
    },
  },
  actions: {
    async setActiveBlindBoxVoucher({ commit }, voucherCode) {
      commit('SET_ACTIVE_BLIND_BOX_VOUCHER', voucherCode);
    },
  },
  getters: {},
};
